import { render } from "./SituationLook.vue?vue&type=template&id=55af067d&scoped=true"
import script from "./SituationLook.vue?vue&type=script&lang=js"
export * from "./SituationLook.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55af067d"]])

export default __exports__